GatorSurvey.app.service("conditionCheckingService", [ConditionCheckingService]);

function ConditionCheckingService() {
    var self = this;
    function findOfferedAnswersinQuestion(question, id) {
        var isTest = getUrlParameter("t") === "1";
        for (var ci = 0; ci < question.offeredAnswers.length; ci++) {
            
            if ((isTest ? question.offeredAnswers[ci].tempId : question.offeredAnswers[ci].id) === id) {
                return question.offeredAnswers[ci];
            }
        }
        throw "item can't be found";
    }

    self.idEquals = function (question, responce, textAnswer) {

        var isTest = getUrlParameter("t") === "1";


        if (responce === null){
            return false;
        }
        var match = false;
        switch (question.type) {
        case "checkbox":
            for (var ca = 0; ca < responce.answers.length; ca++) {
                if (responce.answers[ca] === (isTest ? textAnswer.tempId : textAnswer.id)) {
                    match = true;
                }
            }
            break;
        case "buttonselect":
        case "radio":
        case "dropdown":
                if (responce.answer === (isTest ? textAnswer.tempId : textAnswer.id)) {
                match = true;
            }
            break;
        case "grid":
            for (var i = 0; i < responce.gridAnswers.length; i++) {
                if (responce.gridAnswers[i].id  === textAnswer.gridRowId && responce.gridAnswers[i].selected === textAnswer.gridColumnId) {
                    match = true;
                }
            }
        break;
        default:
            if (responce.answer === textAnswer.text) {
                match = true;
            }
            break;
        }
        return match;
    };

    self.idNotEquals = function (question, responce, textAnswer) {

        var isTest = getUrlParameter("t") === "1";
        if (responce === null) {
            return false;
        }
        var match = false;
        switch (question.type) {
        case "checkbox":
            for (var ca = 0; ca < responce.answers.length; ca++) {
                if (responce.answers[ca] === (isTest ? textAnswer.tempId : textAnswer.id)) {
                    match = true;
                    break;
                }
            }
            break;
        case "buttonselect":
        case "radio":
        case "dropdown":
                if (responce.answer === (isTest ? textAnswer.tempId : textAnswer.id)) {
                match = true;
            }
            break;
        case "grid":
            for (var i = 0; i < responce.gridAnswers.length; i++) {
                if (responce.gridAnswers[i].id === textAnswer.gridRowId && responce.gridAnswers[i].selected === textAnswer.gridColumnId) {
                    match = true;
                }
            }
            break;
        default:
            if (responce.answer === textAnswer.text) {
                match = true;
            }
            break;
        }
        return !match;
    };
    self.isGreaterThan = function (question, responce, textAnswer) {
        var isTest = getUrlParameter("t") === "1";
        if (responce === null) {
            return false;
        }
        var match = false;
        switch (question.type) {
        case "checkbox":
            var compareCheckItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            for (var ci = 0; ci < responce.length; ci++) {
                if (findOfferedAnswersinQuestion(question, responce.answer[ci]).orderNo > compareCheckItemm) {
                    match = true;
                    break;
                }
            }
            break;
        case "buttonselect":
        case "radio":
        case "dropdown":
            var compareOtherItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            if (findOfferedAnswersinQuestion(question, responce.answer).orderNo > compareOtherItemm) {
                match = true;
            }
            break;
        case "grid":
            for (var row = 0; row < question.grid.rows.length; row++) {
                for (var col = 0; col < question.grid.cols.length; col++) {
                    for (var answr = 0; answr < responce.gridAnswers.length; answr++) {
                        if (responce.gridAnswers[answr].id === textAnswer.gridRowId && responce.gridAnswers[answr].selected === textAnswer.gridColumnId) {
                            if (question.grid.rows[row].label + " : " + question.grid.cols[col].label > textAnswer.text) {
                                match = true;
                            }
                        }
                    }
                }
            }
            break;
        default:
            if (responce.answer > textAnswer.text) {
                match = true;
            }
            break;
        }
        return match;
    };
    self.isGreaterThanEqual = function (question, responce, textAnswer) {
        var isTest = getUrlParameter("t") === "1";
        if (responce === null) {
            return false;
        }
        var match = false;
        switch (question.type) {
        case "checkbox":
                var compareCheckItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            for (var ci = 0; ci < responce.length; ci++) {
                if (findOfferedAnswersinQuestion(question, responce.answer[ci]).orderNo >= compareCheckItemm)
                    match = true;
                break;
            }
            break;
        case "buttonselect":
        case "radio":
        case "dropdown":
                var compareOtherItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            if (findOfferedAnswersinQuestion(question, responce.answer).orderNo >= compareOtherItemm) {
                match = true;
            }
            break;
        case "grid":
            for (var row = 0; row < question.grid.rows.length; row++) {
                for (var col = 0; col < question.grid.cols.length; col++) {
                    for (var answr = 0; answr < responce.gridAnswers.length; answr++) {
                        if ( responce.gridAnswers[answr].id === textAnswer.gridRowId && responce.gridAnswers[answr].selected === textAnswer.gridColumnId) {
                            if (question.grid.rows[row].label + " : " + question.grid.cols[col].label >= textAnswer.text) {
                                match = true;
                            }
                        }
                    }
                }
            }
            break;
        default:
            if (responce.answer > textAnswer.text) {
                match = true;
            }
            break;
        }
        return match;
    };
    self.isLessThen = function (question, responce, textAnswer) {
        var isTest = getUrlParameter("t") === "1";
        if (responce === null) {
            return false;
        }
        var match = false;
        switch (question.type) {
        case "checkbox":
                var compareCheckItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            for (var ci = 0; ci < responce.length; ci++) {
                if (findOfferedAnswersinQuestion(question, responce.answer[ci]).orderNo < compareCheckItemm)
                    match = true;
                break;
            }
            break;
        case "buttonselect":
        case "radio":
        case "dropdown":
                var compareOtherItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            if (findOfferedAnswersinQuestion(question, responce.answer).orderNo < compareOtherItemm) {
                match = true;
            }
            break;
        case "grid":
            for (var row = 0; row < question.grid.rows.length; row++) {
                for (var col = 0; col < question.grid.cols.length; col++) {
                    for (var answr = 0; answr < responce.gridAnswers.length; answr++) {
                        if (responce.gridAnswers[answr].id === textAnswer.gridRowId && responce.gridAnswers[answr].selected === textAnswer.gridColumnId) {
                            if (question.grid.rows[row].label + " : " + question.grid.cols[col].label < textAnswer.text) {
                                match = true;
                            }
                        }
                    }
                }
            }
            break;
        default:
            if (responce.answer < textAnswer.text) {
                match = true;
            }
            break;
        }
        return match;
    };
    self.isLessThenEqual = function (question, responce, textAnswer) {
        var isTest = getUrlParameter("t") === "1";
        if (responce === null) {
            return false;
        }
        var match = false;
        switch (question.type) {
        case "checkbox":
                var compareCheckItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            for (var ci = 0; ci < responce.length; ci++) {
                if (findOfferedAnswersinQuestion(question, responce.answer[ci]).orderNo <= compareCheckItemm)
                    match = true;
                break;
            }
            break;
        case "buttonselect":
        case "radio":
        case "dropdown":
                var compareOtherItemm = findOfferedAnswersinQuestion(question, (isTest ? textAnswer.tempId : textAnswer.id)).orderNo;
            if (findOfferedAnswersinQuestion(question, responce.answer).orderNo <= compareOtherItemm) {
                match = true;
            }
            break;
        case "grid":
            for (var row = 0; row < question.grid.rows.length; row++) {
                for (var col = 0; col < question.grid.cols.length; col++) {
                    for (var answr = 0; answr < responce.gridAnswers.length; answr++) {
                        if (responce.gridAnswers[answr].id === textAnswer.gridRowId && responce.gridAnswers[answr].selected === textAnswer.gridColumnId) {
                            if (question.grid.rows[row].label + " : " + question.grid.cols[col].label <= textAnswer.text) {
                                match = true;
                            }
                        }
                    }
                }
            }
            break;
        default:
            if (responce.answer < textAnswer.text) {
                match = true;
            }
            break;
        }
        return match;
    };
    self.isLike = function (question, responce, textAnswer) {
        var isTest = getUrlParameter("t") === "1";
        if (responce === null) {
            return false;
        }
        var match = false;
        switch (question.type) {
        case "checkbox":
            for (var ca = 0; ca < responce.answers.length; ca++) {
                if (responce.answers[ca] === (isTest ? textAnswer.tempId : textAnswer.id)) {
                    match = true;
                }
            }
            break;
        case "buttonselect":
        case "radio":
        case "dropdown":
                if (responce.answer === (isTest ? textAnswer.tempId : textAnswer.id)) {
                match = true;
            }
            break;
        case "grid":
            for (var row = 0; row < question.grid.rows.length; row++) {
                for (var col = 0; col < question.grid.cols.length; col++) {
                    for (var answr = 0; answr < responce.gridAnswers.length; answr++) {
                        if (responce.gridAnswers[answr].id === textAnswer.gridRowId && responce.gridAnswers[answr].selected === textAnswer.gridColumnId) {
                            if (question.grid.rows[row].label + " : " + question.grid.cols[col].label === textAnswer.text) {
                                match = true;
                            }
                        }
                    }
                }
            }
            break;
        default:
            if (responce.answer.indexOf(textAnswer.text) > -1) {
                match = true;
            }
            break;
        }
        return match;
    };
}